/**
 * Klaviyo Popup 防关闭保护（Pandectes Cookies × Klaviyo）
 *
 * 背景
 * - Pandectes（GDPR/Consent）Cookie 弹窗（Banner/Preference）与 Klaviyo（弹窗表单）会同屏。
 * - Klaviyo 内部通常会在全局监听“外部点击/遮罩点击”来关闭弹窗。
 * - 用户点击 Pandectes Cookie UI 时，事件传播可能会触发 Klaviyo 的“外部点击关闭”逻辑，导致误关。
 *
 * 本脚本做什么
 * - 识别用户操作是否发生在 Pandectes Cookie UI 相关区域。
 * - 若命中：在 capture 阶段阻断事件向上冒泡（stopPropagation），并启动短保护窗口。
 * - 若在保护窗口内仍收到 Klaviyo 的 close：用 openForm 事件兜底重开，避免 close->open 抖动。
 *
 * 关键点（便于维护/排查）
 * - COOKIE_ROOT_SEL：Cookie UI 的“命中区域”选择器集合。若 Pandectes UI 结构变化，只需扩展此选择器。
 * - GUARD_MS：保护窗口时长。若观察到偶发 close，可适当加大。
 * - 事件拦截范围：只拦截 pointer/mouse/touch 的按下/交互类事件，不依赖 click 事件（避免影响 Pandectes 自己的同意/拒绝流程）。
 *
 * 说明
 * - 该脚本的目标是“阻止误判为外部点击”，不改动 Pandectes 或 Klaviyo 的业务数据逻辑。
 */
(function () {
  'use strict';

  // Pandectes cookie banner / modal 的根节点区域（不同页面 DOM 结构可能略有差异）
  var COOKIE_ROOT_SEL =
    '#pandectes-banner, .cc-window-wrapper, .cc-window, .pd-cookie-banner-window, .cc-compliance, ' +
    '#pd-cp-preferences, .pd-cp-ui-container, .pd-cp-ui, [id^="pd-cp"], *[class*="pd-cp-"]';
  // 允许 Klaviyo 内部 close->open 的短延迟窗口
  var GUARD_MS = 1500;

  var guardUntil = 0;
  var openFormId = null;
  var reopenScheduled = false;

  function armGuard() {
    guardUntil = Date.now() + GUARD_MS;
  }

  function shouldGuardClose() {
    return openFormId && Date.now() < guardUntil;
  }

  function reopenForm(formId) {
    if (!formId || reopenScheduled) return;
    reopenScheduled = true;
    window.setTimeout(function () {
      reopenScheduled = false;
      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);
    }, 80);
  }

  window.addEventListener('klaviyoForms', function (e) {
    var detail = e.detail;
    if (!detail || !detail.type) return;

    if (detail.type === 'open') {
      openFormId = detail.formId;
      return;
    }

    if (detail.type === 'close' && shouldGuardClose()) {
      reopenForm(openFormId);
    }
  });

  // 核心：只拦截 Pandectes cookie 弹窗内部的“按下/鼠标操作”传播，
  // 不拦截 click，让 Pandectes 仍能正常处理同意/关闭逻辑；
  // 使用 capture 阶段，尽量在 Klaviyo 的“外部点击关闭”监听器之前阻断传播。
  function onCookiePointerEvent(e) {
    if (!e || !e.isTrusted) return;
    var t = e.target;
    if (!t || !t.closest) return;
    if (!t.closest(COOKIE_ROOT_SEL)) return;

    armGuard();
    e.stopPropagation();
  }

  ['pointerdown', 'mousedown', 'mouseup', 'touchstart', 'touchend'].forEach(function (ev) {
    document.addEventListener(ev, onCookiePointerEvent, true);
  });
})();
